export const deviceEmptyMessage = (
  itemCount: number | undefined,
  unfilteredMessage: string,
  hasFilters = false
) => {
  if (itemCount === undefined) return undefined;
  if (itemCount > 0) return 'No devices found';
  return hasFilters ? 'No devices match the filters' : unfilteredMessage;
};
